// sessionStorage-backed so the dismissal survives client-side navigation (Topbar and
// MobileBottomNavbar are both remounted on every route change in this app) AND survives
// a page refresh - it only clears when the browser tab/session actually ends, per product
// requirement ("once closed, never reappear in the current session").
//
// Falls back to an in-memory flag when sessionStorage isn't available: during SSR (no
// `window`), and in browsers/modes (e.g. some private-browsing configurations) where
// reading or writing storage throws. The in-memory fallback only holds for the current
// page load in those cases, same as before.
const STORAGE_KEY = 'emailVerificationPromptDismissed';

let inMemoryDismissed = false;

export const isEmailVerificationPromptDismissed = () => {
  if (typeof window === 'undefined') {
    return inMemoryDismissed;
  }
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch (e) {
    return inMemoryDismissed;
  }
};

export const dismissEmailVerificationPrompt = () => {
  inMemoryDismissed = true;
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.sessionStorage.setItem(STORAGE_KEY, 'true');
  } catch (e) {
    // sessionStorage unavailable - the in-memory fallback above still holds for the
    // rest of this page load.
  }
};
